import { AssessmentInfo, Html, IcfCategory } from "../assessment";

export const aratInfo: AssessmentInfo = {
    shortName: "ARAT",
    fullName: "Action Research Arm Test",
    reportDescription: `\
<p>Der Action Research Arm Test (ARAT) ist ein standardisierter Test zur Bewertung der oberen Extremitätenfunktion. Er misst die Fähigkeit des Patienten, spezifische Aufgaben mit Arm und Hand durchzuführen, wie Greifen, Halten und Verschieben von Objekten. Der Test besteht aus vier Kategorien: Greifen, Greifen und Festhalten, Präzisionsgriff und Armbewegungen. Der ARAT hilft dabei, Fortschritte und Einschränkungen in der Arm- und Handbewegung eines Patienten objektiv zu erfassen und zu dokumentieren.</p>`,
}

export const aratSubtestList: AratSubtest[] = [
    {
        name: "Greifen",
        entryReference: `\
<ul>
    <li>3 Punkte: Wenn der Patient das Objekt richtig gegriffen, platziert und auch losgelassen hat. Wenn der Patient das Objekt nach Erreichen der Endposition loslässt, dieses beim Zurückziehen der Hand aber trotzdem noch umwirft, wird dies nicht mit Punktabzug geahndet.</li>
    <li>2 Punkte: Wenn der Patient das Regal erreicht, er aber das Objekt am Endpunkt nicht loslassen kann.</li>
    <li>1 Punkt: Wenn der Patient den Gegenstand greifen und vom Tisch abheben kann, er aber das Regal nicht erreicht (weil beispielsweise die Schulterfunktion eingeschränkt ist).</li>
    <li>0 Punkte: Wenn der Patient den Gegenstand nicht greifen und anheben kann.</li>
</ul>`,
        icfCategories: ["d430", "d440", "d445"],
        tasks: [
            aratTask("Holzwürfel (10 cm)"),
            aratTask("Holzwürfel (2,5 cm)"),
            aratTask("Holzwürfel (5 cm)"),
            aratTask("Holzwürfel (7,5 cm)"),
            aratTask("Holzkugel (7,5 cm)"),
            aratTask("Stein (10 × 2,5 × 1 cm)"),
        ],
    },
    {
        name: "Griff",
        entryReference: `\
<ul>
    <li>3 Punkte: Der Test wird normal ausgeführt (vollständig und korrekt).</li>
    <li>2 Punkte: Der Patient führt die Aufgabe zwar aus, braucht jedoch eine sehr lange Zeit dazu und hat große Schwierigkeiten dabei. Die Ausführung ist sehr langsam oder sehr ungeschickt.</li>
    <li>1 Punkt: Der Patient führt die Aufgabe nur teilweise aus. Die Stufe wird vergeben, wenn der Patient fähig ist, den Gegenstand hochzuheben.</li>
    <li>0 Punkte: Der Patient ist nicht fähig, irgendwelche Teile der Aufgabe durchzuführen. Es ist ihm nicht einmal möglich, Gegenstände von ihren Plätzen oder auf den Tisch zu schieben.</li>
</ul>`,
        icfCategories: ["d430", "d440", "d445"],
        tasks: [
            aratTask("Wasser umgießen"),
            aratTask("Röhrchen (2,25 × 11,5 cm) platzieren"),
            aratTask("Röhrchen (1 × 16 cm) platzieren"),
            aratTask("Unterlegscheibe ergreifen und aufstecken"),
        ],
    },
    {
        name: "Präzisionsgriff",
        entryReference: `\
<ul>
    <li>3 Punkte: Wenn der Patient das Objekt richtig gegriffen, platziert und auch losgelassen hat. Wenn der Patient das Objekt nach Erreichen der Endposition loslässt, dieses beim Zurückziehen der Hand aber trotzdem noch umwirft, wird dies nicht mit Punktabzug geahndet.</li>
    <li>2 Punkte: Wenn der Patient das Regal erreicht, er aber das Objekt am Endpunkt nicht loslassen kann.</li>
    <li>1 Punkt: Wenn der Patient den Gegenstand greifen und vom Tisch abheben kann, er aber das Regal nicht erreicht (weil beispielsweise die Schulterfunktion eingeschränkt ist).</li>
    <li>0 Punkte: Wenn der Patient den Gegenstand nicht greifen und anheben kann.</li>
</ul>`,
        icfCategories: ["d430", "d440", "d445"],
        tasks: [
            aratTask("kleine Kugel (6 mm) mit Daumen und Ringfinger"),
            aratTask("Murmel (1,5 cm) mit Daumen und Zeigefinger"),
            aratTask("kleine Kugel (6 mm) mit Daumen und Mittelfinger"),
            aratTask("kleine Kugel (6 mm) mit Daumen und Zeigefinger"),
            aratTask("Murmel (1,5 cm) mit Daumen und Ringfinger"),
            aratTask("Murmel (1,5 cm) mit Daumen und Mittelfinger"),
        ],
    },
    {
        name: "Basale Armbewegung",
        entryReference: `\
<ul>
    <li>3 Punkte: Leicht ausgleichende Bewegungen mit dem Körper sind während der Aufgaben erlaubt.</li>
    <li>2 Punkte (bei Aufgabe 1): Wenn der Kopf erst dann nach vorn gebeugt wird, nachdem die Verlängerung des Nackens erreicht wurde, um nunmehr die korrekte Endposition einzunehmen.</li>
    <li>1 Punkt: Wenn der Patient seinen Kopf nach vorn beugt, um die Ausführung zu erleichtern, denn dann ist die Aufgabe nicht komplett gelöst.</li>
    <li>0 Punkte: Wenn der Patient keinen Teil der Aufgabe durchführen kann.</li>
</ul>`,
        icfCategories: ["b760"],
        tasks: [
            aratTask("Hand an den Hinterkopf bringen"),
            aratTask("Hand auf den Kopf bringen"),
            aratTask("Hand zum Mund bringen"),
        ],
    },
]

export interface AratSubtest {
    name: string;
    entryReference: Html;
    icfCategories: IcfCategory[];
    tasks: AratTask[];
}

export interface AratTask {
    name: string;
    maxScore: number;
    sided: boolean;
}

function aratTask(name: string): AratTask {
    return {
        name,
        maxScore: 3,
        sided: true,
    }
}